module.exports = __webpack_public_path__ + "static/9-a3d0a36ad8a2473fd01f0ac7ebf91cee.jpg";